import { ComponentStyleConfig } from '@chakra-ui/react';

export const SearchBar: ComponentStyleConfig = {
  parts: ['container', 'input', 'searchIcon', 'closeIcon'],
  baseStyle: {
    container: {
      height: '49px',
      justifyContent: 'center',
      '.chakra-input__left-element': {
        width: '32px',
      },
    },
    input: {
      _placeholder: {
        color: 'textPlaceholder',
        opacity: 1,
      },
      paddingInlineStart: '36px',
      paddingInlineEnd: '49px',
    },
    searchIcon: {
      height: 5,
      width: 5,
      ml: 3,
      color: 'iconBase',
    },
    closeIcon: {
      display: 'inline-flex',
      width: 'inherit',
      justifyContent: 'center',
      border: 'none',
      borderRadius: 0,
      shadow: 'none',
      '&:hover:not(:disabled)': {
        shadow: 'none',
      },
      '&:active:not(:disabled)': {
        shadow: 'none',
      },
      '&:focus:not(:disabled)': {
        shadow: 'none',
      },
      color: 'iconBase',
      _hover: {
        color: 'textBase',
      },
    },
  },
  variants: {
    animated: {
      input: {
        width: 160,
        border: 'none',
        borderRadius: '0 !important',
        borderBottom: '1px solid',
        transition: 'width 0.3s, background-color 0.3s, border-radius 0.3s',
        _focus: {
          width: 256,
          backgroundColor: 'surface1',
          border: `1px solid`,
          borderColor: 'borderBase',
          borderRadius: '8px !important',
          transition: 'width 0.3s, background-color 0.3s, border-radius 0.3s',
        },
      },
    },
    simple: {},
  },
  defaultProps: {
    variant: 'simple',
  },
};
